import { render, staticRenderFns } from "./Search-Result.vue?vue&type=template&id=a5772158&scoped=true&"
import script from "./Search-Result.vue?vue&type=script&lang=js&"
export * from "./Search-Result.vue?vue&type=script&lang=js&"
import style0 from "./Search-Result.vue?vue&type=style&index=0&id=a5772158&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5772158",
  null
  
)

export default component.exports